import GlobalPopper from "./GlobalPopper.vue";

export { initGlobalPopper } from "./globalPopper";
export { PopperType } from "./shared";

export default GlobalPopper;
